export const page = {
	title: "Productos",
	description: "Listado y configuración de artículos vendidos al cliente final.",
	permissionError: "No tienes los permisos",
	addProduct: "Agregar producto",
	bulkImportProducts: "Importar productos en masa",
};
